
angular.module('mean.contacts').controller('BusinessContactController', ['$scope', 'Global', 'Contacts', 'MeanUser', 'ngDialog', 'Messages', 'toaster', '$location', 'Requests', 'userService', 'Builders', 'Trades', '$filter', '$q', '$rootScope', 'contactService', 'Users',
  function($scope, Global, Contacts, MeanUser, ngDialog, Messages, toaster, $location, Requests, userService, Builders, Trades, $filter, $q, $rootScope, contactService, Users) {
    $scope.global = Global;
    $scope.package = {
      name: 'contacts'
    };

    $scope.user = MeanUser.user;

    $scope.business_contacts = [];
    $scope.contacts = $scope.$parent.contacts;
    $scope.is_builder = $scope.$parent.is_builder;
    $scope.builder_info = $scope.$parent.builder_info;

    $scope.sendRequest = function() {
        var body = $scope.user.name + ' has sent a contact request.  To accept <a href="' +
            $location.absUrl() + '">Click Here</a>';

        if($scope.is_builder) {
            //we are getting a builder so we need to take whatever
            //username they put in and return the main accounts user data
            var main_username = userService.getCompanyCode($scope.new_contact_username);
            var trade_code = userService.getTradeCode($scope.new_contact_username);

            //builders cannot add builders
            if(trade_code === '00') {
                toaster.pop('error', 'Contact Request', 'Cannot create contact request.');
                return;
            }

            main_username = trade_code + main_username + '0000';

            Users.query({'username': main_username}, function(user) {
                if(user.length !== 1) {
                    toaster.pop('error', 'Contact Request', 'Cannot create contact request.  Unknown user.');
                    return;
                }

                Requests.query({'requestor': $scope.user._id,
                                'requestee': user[0]._id},
                                function(results) {

                    if(results.length > 0) {
                        toaster.pop('error', 'Contact Request', 'Request Already Exists');
                        return;
                    }

                    var request = new Requests({
                        requestor: $scope.user._id,
                        requestee: user[0]._id,
                        type: 'Business',
                        date: new Date
                    });

                    request.$save(function(result) {
                        var message = new Messages({
                            sender: $scope.user._id,
                            receiver: user[0]._id,
                            date: new Date(),
                            status: 'unread',
                            folder: 'inbox',
                            subject: 'New Contact Request',
                            body: body
                        });

                        $rootScope.$broadcast('update-request-list');
                        toaster.pop('success', 'Contact Request', 'Request has been sent.');
                        $scope.new_contact_username = '';
                    }, function(error) {
                        toaster.pop('error', 'Contact Request', 'There is a problem with your request.');
                    });
                });
            });
        } else {
            //we are getting a builder so we need to take whatever
            //username they put in and return the main accounts user data
            var main_username = userService.getCompanyCode($scope.new_contact_username);
            main_username = '00' + main_username + '0000';

            //do we already have this contact
            var in_list = $filter('filter')($scope.contacts.builders, {
                'username': $scope.new_contact_username}, true);

            if(in_list.length > 0) {
                toaster.pop('error', 'Contact Request', 'Requested contact already exists');
                return;
            }

            //trades can only add builders
            if(userService.getTradeCode($scope.new_contact_username) !== '00') {
                toaster.pop('error', 'Contact Request', 'Cannot create contact request.');
                return;
            }

            Users.query({username: main_username}, function(user) {
                if(user.length !== 1) return;

                Requests.query({'requestor': $scope.user._id, 'requestee': user[0]._id},
                    function(results) {
                        if(results.length > 0) {
                        toaster.pop('error', 'Contact Request', 'Request Already Exists');
                        return;
                    }

                    var request = new Requests({
                        requestor: $scope.user._id,
                        requestee: user[0]._id,
                        type: 'Business',
                        date: new Date
                    });

                    request.$save(function(result) {
                        var message = new Messages({
                            sender: $scope.user._id,
                            receiver: user[0]._id,
                            date: new Date(),
                            status: 'unread',
                            folder: 'inbox',
                            subject: 'New Contact Request',
                            body: body
                        });

                        $rootScope.$broadcast('update-request-list');
                        $scope.new_contact_username = '';
                        toaster.pop('success', 'Contact Request', 'Request has been sent.');
                    }, function(error) {
                        toaster.pop('error', 'Contact Request', 'There is a problem with your request.');
                    });
                });
            });
        }
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/contacts/public/controllers/businessContactController.js